<template>
    <div :class="$style.invoiceDetail">
        <el-divider content-position="left">发票与收款方式对比</el-divider>

        <!-- 日期筛选区域 -->
        <div :class="$style.filterArea">
            <el-date-picker v-model="searchArr.dateRange" type="monthrange" range-separator="至" start-placeholder="开始月份"
                end-placeholder="结束月份" format="yyyy-MM" value-format="yyyy-MM" @change="handleDateChange"
                :class="$style.datePicker" @clear="handleDateClear" clearable></el-date-picker>

            <el-button type="primary" size="mini" @click="handleQuery" :class="$style.queryBtn">
                查询
            </el-button>

            <!-- <el-button type="default" size="mini" @click="handleReset" :class="$style.resetBtn">
                重置
            </el-button> -->
        </div>

        <!-- 数据表格 -->
        <el-table :data="tableData" border stripe :class="$style.table" v-loading="loading"
            element-loading-text="加载中...">
            <el-table-column label="收款方式" width="210" align="center">
                <template slot-scope="scope" v-if="scope.row.money_in">
                    {{ scope.row.money_in.category_name }}
                </template>
            </el-table-column>
            <el-table-column prop="total_money" label="总金额(元)" width="120" align="center"></el-table-column>
            <el-table-column prop="invoiced_money" label="已开票金额(元)" width="160" align="center"></el-table-column>
            <el-table-column prop="actual_invoice_amount" label="实际开票金额(元)" width="150"
                align="center"></el-table-column>
            <el-table-column prop="uninvoiced_money" label="未开票金额(元)" width="160" align="center"></el-table-column>
        </el-table>

        <!-- 无数据提示 -->
        <div :class="$style.emptyTip" v-if="tableData.length === 0 && !loading">
            <el-empty description="暂无数据"></el-empty>
        </div>
    </div>
</template>

<script>
import { hyperfHost } from '@/YsyCollections/host/hyperfHost.js'
export default {
    name: 'InvoiceComparison',
    data() {
        return {
            searchArr: {
                // 日期范围
                dateRange: [],
            },
            // 表格数据
            tableData: [],
            // 加载状态
            loading: false
        }
    },
    created() {
        // 初始化时设置默认日期范围为近3个月
        this.initDefaultDateRange();
        // 加载数据
        this.fetchTableData();
    },
    methods: {
        // 初始化默认日期范围
        initDefaultDateRange() {
            const endDate = new Date();
            const startDate = new Date();
            startDate.setMonth(startDate.getMonth() - 2); // 三个月前

            this.searchArr.dateRange = [
                this.formatDate(startDate),
                this.formatDate(endDate)
            ];
        },

        // 格式化日期为yyyy-MM
        formatDate(date) {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            return `${year}-${month}`;
        },

        // 处理日期范围变化
        handleDateChange() {
            // // 可以在这里直接触发查询，或者留到点击查询按钮
            // console.log(this.dateRange)
            // if (!this.dateRange) this.fetchTableData()
        },

        // 查询数据
        handleQuery() {
            if (!this.searchArr.dateRange || this.searchArr.dateRange.length !== 2) {
                this.$message.warning('请选择完整的日期范围');
                return;
            }
            this.fetchTableData();
        },

        // 重置筛选条件
        handleReset() {
            this.initDefaultDateRange();
            this.fetchTableData();
        },

        // 获取表格数据
        fetchTableData() {
            this.loading = true;
            this.$axios.get(`${hyperfHost}qyh/invoice_detail/index`, {
                loadingClose: true,
                params: this.searchArr
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.loading = false;
                    this.tableData = data.data
                }
            }).catch()
        },

        // 生成模拟数据
        generateMockData(startMonth, endMonth) {
            const data = [];
            const start = new Date(startMonth);
            const end = new Date(endMonth);

            let current = new Date(start);

            // 收款方式列表
            const paymentMethods = ['银行转账', '支付宝', '微信支付', '现金', '支票'];

            while (current <= end) {
                const year = current.getFullYear();
                const month = current.getMonth() + 1;
                const dateStr = `${year}-${month.toString().padStart(2, '0')}`;

                // 随机生成数据
                const invoiceNum = Math.floor(Math.random() * 50) + 10;
                const invoiceAmount = Math.floor(Math.random() * 100000) + 50000;
                const paymentMethod = paymentMethods[Math.floor(Math.random() * paymentMethods.length)];
                const paymentAmount = invoiceAmount + (Math.floor(Math.random() * 20000) - 10000);
                const difference = invoiceAmount - paymentAmount;

                data.push({
                    date: dateStr,
                    invoiceNum,
                    invoiceAmount,
                    paymentMethod,
                    paymentAmount,
                    difference,
                    remark: difference === 0 ? '金额一致' : difference > 0 ? '发票金额大于收款' : '收款金额大于发票'
                });

                // 移动到下个月
                current.setMonth(current.getMonth() + 1);
            }

            return data;
        },

        // 格式化金额显示
        formatCurrency(row, column, cellValue) {
            if (cellValue === undefined) return '0.00';
            return cellValue.toFixed(2);
        },

        // 根据差异金额设置单元格样式
        cellStyle({ row, column, rowIndex, columnIndex }) {
            if (row.difference > 0) {
                return { color: 'red' };
            } else if (row.difference < 0) {
                return { color: 'green' };
            }
            return { color: '#333' };
        },
        handleDateClear() {
            console.log(111)
            this.fetchTableData()
        }
    }
}
</script>

<style module>
.invoiceDetail {
    padding: 1.82rem 0.4rem 0.4rem 0.4rem;
    background-color: #fff;
    height: calc(100vh - 2rem);
    overflow-y: auto;
}

.filterArea {
    display: flex;
    align-items: center;
    margin-bottom: 0.6rem;
    padding: 0.4rem;
    background-color: #f5f7fa;
    border-radius: 4px;
}

.datePicker {
    width: 360px;
    margin-right: 0.4rem;
}

.queryBtn {
    margin-right: 0.2rem;
}

.resetBtn {
    margin-right: 0.2rem;
}

.table {
    width: 100%;
    margin-bottom: 1rem;
}

.emptyTip {
    margin: 2rem 0;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/tyc_order/InvoiceDetail.vue